module.exports = __webpack_public_path__ + "static/media/berry-frost3@3x.dbec87b3.png";